import { resourcesService } from "app/services";
import { useQuery } from "@tanstack/react-query";

export function useDenominacionesSociales() {
  const denominacionesSociales = useQuery({
    queryKey: ["denominaciones-sociales"],
    queryFn: resourcesService.getDenominacionesSociales,
  });

  return denominacionesSociales;
}
